import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Alert } from 'shared/mui/Alert/Alert';

type FilterIdDialogNotFoundIdAlertProps = {
  isFetching: boolean;
  ids?: string[];
};

export const FilterIdDialogNotFoundIdAlert: React.FC<FilterIdDialogNotFoundIdAlertProps> = ({
  isFetching,
  ids,
}) => {
  const translate = useTypedTranslate();

  if (isFetching || !ids || ids?.length <= 0) {
    return <></>;
  }

  return (
    <Alert severity="warning" sx={{ margin: '15px 0 10px 0' }}>
      {ids?.length} {translate('app.filter.idNotFound')}.
    </Alert>
  );
};
